module.exports = __webpack_public_path__ + "components/media-kit/static/sbban-desktop-18cbea97de3c3b6b3091205d8b4d1072.png";